import React from "react";
import Search from "../components/Search";
import image1 from "../images/image1.jpg";
import image2 from "../images/image2.jpg";
import image3 from "../images/image3.jpg";
import image4 from "../images/image4.jpg";
import image5 from "../images/image5.jpg";
import female from "../images/female.png";
import heartFill from "../images/fill heart.png";
import location from "../images/location.png";
import heartIcon from "../images/Image(2).png";
import { useNavigate } from "react-router-dom";
function Home({ setId }) {
  const navigate = useNavigate();

  const names = ["Jiwoo", "Seoyeon", "Haeun", "Minji", "Hyejin"];
  const locations = [
    "Incheon, South Korea",
    "Daegu, South Korea",
    "Seoul, South Korea",
    "Busan, South Korea",
    "Jeonju, South Korea",
  ];
  const images = [image1, image2, image3, image4, image5];
  const kms = ["1.2 km", "3.8 km", "5.4 km", "7.1 km", "22.7 km"];
  const hearts = [true, false, true, true, false];

  const handleClick = () => {
    navigate("/about");
  };
  return (
    <div>
      <div className="h-[36rem]  overflow-scroll pl-6 pr-6 pt-6 w-[22rem] rounded-xl bg-[#ffffff]">
        <span className="flex flex-row">
          <h1 className="text-[22px] mt-0  font-semibold">Friendora</h1>
        </span>
        <Search />

        <div className="flex  min-h-min max-h-max gap-4 flex-col  mt-6  w-full">
          {names.map((ind, key) => (
            <div
              key={key}
              onClick={() => {
                handleClick();
                setId(key);
              }}
              className="h-[7.50rem] flex flex-row w-full"
            >
              <img
                className="h-full rounded-xl"
                src={images[key]}
                alt="dog-image"
              />
              <div className="flex gap-2 mt-2 pl-3 flex-col">
                <span className="flex flex-row">
                  <h2 className="text-2xl font-semibold">{ind}</h2>
                  <img
                    className="h-[15px] mt-2 pl-2"
                    src={female}
                    alt="female"
                  />
                </span>
                <span className="flex flex-row">
                  <p>{locations[key]}</p>
                  <img
                    className="h-[15px] cursor-pointer ml-2 mt-1"
                    src={hearts[key] ? heartFill : heartIcon}
                    alt="heartIcon"
                  />
                </span>
                <span className="flex flex-row">
                  <img
                    src={location}
                    className="h-[15px] mt-1"
                    alt="location"
                  />
                  <p className="ml-2">{kms[key]}</p>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Home;
